module.exports = __webpack_public_path__ + "static/media/tzc.36de4721.svg";